class SelectionManager {
  selectionData: any[]

  listable: any[]

  delistable: any[]

  relistable: any[]

  reviewable: any[]

  recyclable: any[]

  productAttributesOverridable: any[]

  findEachInData = data => id => data.find(d => d._id === id)

  setSelectionData = (selectedIds, dataList) => {
    this.selectionData = selectedIds.map(this.findEachInData(dataList)).filter(s => s)
    this.listable = this.getSelectionMatches(['PENDING', 'LISTING_FAILED', 'LISTING'])
    this.reviewable = this.getSelectionMatches(['PENDING', 'LISTING_FAILED', 'LISTING', 'RELISTING_FAILED'])
    this.delistable = this.getSelectionMatches(['LISTED', 'DELISTING_FAILED', 'MODIFY_FAILED'])
    this.relistable = this.getSelectionMatches([
      'DELISTED',
      'EXPIRED',
      'PURGED',
      'PENDING_RELISTING',
      'RELISTING_FAILED'
    ])
    this.recyclable = this.getSelectionMatches(['DELISTED', 'EXPIRED'])
    this.productAttributesOverridable = this.getSelectionMatches([
      'LISTED',
      'PENDING',
      'DELISTED',
      'EXPIRED',
      'PENDING_RELISTING',
      'MODIFY_FAILED'
    ]).filter(d => !d.productOverriddenValues) // no current overrides
  }

  getSelectionMatches = allowedStates => {
    const allowedStatesSet = new Set(allowedStates)
    return this.selectionData.reduce((acc, curr) => (allowedStatesSet.has(curr.state) ? [...acc, curr] : acc), [])
  }

  getDelistableCount = () => this.delistable.length

  getListableCount = () => this.listable.length

  getRelistableCount = () => this.relistable.length

  getReviewableCount = () => this.reviewable.length

  getRecyclableCount = () => this.recyclable.length

  getProductAttributesOverridableCount = () => this.productAttributesOverridable.length
}

export default SelectionManager
